"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsComponent = void 0;
const checkbox_group_1 = require("client/components/checkbox-group");
const checkbox_item_1 = require("client/components/checkbox-group/checkbox-item");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const switch_1 = require("client/components/material/switch/switch");
const text_field_1 = require("client/components/material/text-field");
const callable_1 = require("client/components/ui/callable");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment-timezone");
const ramda_1 = require("ramda");
const React = require("react");
const setting_1 = require("shared/setting");
const time_picker_1 = require("../material/timepicker/time-picker");
require("./settings.less");
const material_ui_1 = require("material-ui");
const store_1 = require("../../modules/inventory-order/store"); // D-002.802
const confirmation_modal_1 = require("../../components/confirmation-modal"); // E-105 new
const emailSettingIds = [
    "eowEmailAddress",
    "sendProvAlertEmails",
    "sendUserAlertEmails",
    "sendUserCycleCountAlertEmail",
    "sendClinicAdminCycleCountAlertEmail",
    "sendClinicManagerCycleCountAlertEmail",
    "sendSiteAlertEmailsAdmin",
    "sendSiteAlertEmailsManager",
    "sendEmailNotificationFrequency",
    "sendIntentNotificationAdmin",
    "sendIntentNotificationClinicAdmin",
    "sendIntentNotificationClinicManager",
    "sendIntentNotificationClinicUser",
    "sendIntentNotificationManager",
    "sendIntentNotificationUser"
];
// E-053
const emailSettingOfOrderApproval = [
    "orderApprovalEmailAddress"
];
const checkboxGroupData = [
    { id: 0, label: "daily" },
    { id: 1, label: "weekly" }
];
let SettingsComponent = class SettingsComponent extends React.Component {
    constructor() {
        super(...arguments);
        /** Unsaved CardPointe POS Ability switch; the site flag (and Financial tab) changes only after Save succeeds. */
        this.cardPointePosAbility = false;
        this.checkboxSelections = {
            daily: false,
            weekly: false
        };
        this.componentDidMount = async () => {
            const { data, site } = this.props;
            this.data = ramda_1.merge(this.data, data);
            this.site = site;
            this.syncCardPointePosAbility(site);
            const cbSel = this.checkboxSelections;
            const val = this.data.sendEmailNotificationFrequency.value;
            if (!!val && val === "daily") {
                cbSel.daily = true;
                cbSel.weekly = false;
            }
            else if (!!val) {
                cbSel.daily = false;
                cbSel.weekly = true;
            }
            await this.loadCompanyInfoOnce(site);
        };
        this.renderEmailSettings = (entry, index) => {
            const [title, settings] = entry;
            const { defaultData } = this.props;
            return (React.createElement("div", { key: index },
                React.createElement(material_ui_1.Typography, { className: "settings-title" }, title),
                React.createElement("div", { className: "settings-email-group" }, settings.map((item, index) => {
                    const setting = this.data && this.data[item.id];
                    const defaultValue = defaultData[item.id];
                    return (React.createElement(checkbox_1.MaterialCheckbox, { key: index, className: "settings-checkbox", checked: (setting && !!setting.value) ||
                            !!item.value ||
                            (defaultValue && !!defaultValue.value), label: setting === null || setting === void 0 ? void 0 : setting.label, onAction: this.handleCheckBox(item.id) }));
                }))));
        };
        this.onHandleClickCheckboxItem = (item) => {
            this.frequencyDaily = item.label === "daily";
            this.checkboxSelections.daily = this.frequencyDaily;
            this.checkboxSelections.weekly = !this.frequencyDaily;
            this.data.sendEmailNotificationFrequency.value = item.label;
            callable_1.callable(this.props.onChange)(this.data);
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            const field = this.data[fieldName];
            if (field) {
                field.value = value;
            }
            callable_1.callable(this.props.onChange)(this.data);
        };
        this.handleCheckBox = (fieldName) => () => {
            const field = this.data[fieldName];
            if (field) {
                field.value = !!field.value ? 0 : 1;
            }
            callable_1.callable(this.props.onChange)(this.data);
        };
        this.handleChangeTime = (fieldName) => (value) => {
            const field = this.data[fieldName];
            if (field) {
                field.value = moment(value).format("hh:mm a");
            }
            callable_1.callable(this.props.onChange)(this.data);
        };
    }
    async loadCompanyInfoOnce(site) {
        var _a, _b;
        const siteId = site && site.id;
        if (!siteId || siteId === this.companyInfoSiteId)
            return;
        this.companyInfoSiteId = siteId;
        const companyInfo = await store_1.inventoryOrderStore.loadSiteComapnyDetailsInfo(siteId); // D-002.802
        if (!companyInfo || !companyInfo[0]) {
            this.companyInfoSiteId = undefined; // allow a retry on the next prop update
            return;
        }
        this.allowCompanyCopayCollection = companyInfo[0].allowCompanyCopayCollection == 1 ? true : false; // D-002.802
        this.changeUserStatusForEsign = companyInfo[0].allowUsersForEsign == 1 ? true : false; // C-108.3
        this.claimApprovalDeterminationValue = (_a = companyInfo[0]) === null || _a === void 0 ? void 0 : _a.claimApprovalDetermination; // E-105
        this.CompanyMinTransactionFeeValue = (_b = companyInfo[0]) === null || _b === void 0 ? void 0 : _b.CompanyMinTransactionFee; // E-105
    }
    /** Reloads the switch from the saved site, without wiping an unsaved toggle on unrelated re-renders. */
    syncCardPointePosAbility(site) {
        const saved = !!(site && site.allowSiteCopayCollection);
        const siteId = site && site.id;
        if (siteId !== this.cardPointePosSiteId ||
            saved !== this.cardPointePosSaved) {
            this.cardPointePosAbility = saved;
        }
        this.cardPointePosSiteId = siteId;
        this.cardPointePosSaved = saved;
    }
    async componentWillReceiveProps(props) {
        this.data = props.data;
        this.site = props.site;
        if (props.resetNonce !== this.props.resetNonce) {
            this.cardPointePosSiteId = undefined;
            this.cardPointePosSaved = undefined;
            this.currentDropValue = props.site && props.site.allowSiteForSelection;
        }
        this.syncCardPointePosAbility(props.site);
        const cbSel = this.checkboxSelections;
        const val = this.data.sendEmailNotificationFrequency.value;
        if (!!val && val === "daily") {
            cbSel.daily = true;
            cbSel.weekly = false;
        }
        else if (!!val) {
            cbSel.daily = false;
            cbSel.weekly = true;
        }
        await this.loadCompanyInfoOnce(props.site);
        this.forceUpdate();
    }
    renderItem(item, index) {
        const setting = this.data && this.data[item.id];
        const defaultValue = this.props.defaultData[item.id];
        return (React.createElement("div", { key: index }, setting &&
            setting.type !== setting_1.ItemTypes.Time &&
            setting.type !== setting_1.ItemTypes.Group &&
            setting.type !== setting_1.ItemTypes.Boolean ? (React.createElement(text_field_1.MaterialTextField, { className: "settings", label: setting.label
                ? setting.label
                : item.label, value: (setting === null || setting === void 0 ? void 0 : setting.value) ? setting === null || setting === void 0 ? void 0 : setting.value : item.value, onChange: this.handleChangeString(item.id) })) : setting &&
            setting.type !== setting_1.ItemTypes.Group &&
            setting.type !== setting_1.ItemTypes.Boolean ? (React.createElement(time_picker_1.MaterialTimePicker, { value: ((setting === null || setting === void 0 ? void 0 : setting.value) &&
                moment(setting.value, "hh:mm a").format("M/D/YYYY hh:mm a")) ||
                (item.value &&
                    moment(item.value, "hh:mm a").format("M/D/YYYY hh:mm a")) ||
                ((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) &&
                    moment(defaultValue.value, "hh:mm a").format("M/D/YYYY hh:mm a")) ||
                "", label: item.label, onChange: this.handleChangeTime(item.id) })) : setting && setting.type !== setting_1.ItemTypes.Group ? (React.createElement(React.Fragment, null,
            (setting && setting.id === "sendSiteAlertEmailsAdmin") ||
                item.id === "sendSiteAlertEmailsAdmin" ||
                (defaultValue && defaultValue.id === "sendSiteAlertEmailsAdmin") ? (React.createElement(material_ui_1.Typography, { className: "settings-title", variant: "title" }, "Turn on email notifications to pharmacy for expiring licenses/certifications sent to:")) : null,
            React.createElement(checkbox_1.MaterialCheckbox, { checked: (setting && !!setting.value) ||
                    !!item.value ||
                    (defaultValue && !!defaultValue.value), label: (setting === null || setting === void 0 ? void 0 : setting.label) || item.label || (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.label), onAction: this.handleCheckBox(item.id) }))) : (React.createElement(React.Fragment, null,
            React.createElement(material_ui_1.Typography, { className: "settings-title", variant: "title" }, (setting === null || setting === void 0 ? void 0 : setting.label) || item.label || (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.label)),
            this.renderCheckboxGroup()))));
    }
    renderCheckboxGroup() {
        return (React.createElement(checkbox_group_1.CheckboxGroup, { data: checkboxGroupData, 
            // eslint-disable-next-line react/jsx-no-bind
            renderItem: this.renderCheckboxItem.bind(this) }));
    }
    renderCheckboxItem(item) {
        return (React.createElement(checkbox_item_1.CheckboxItem, { checked: this.checkboxSelections[item.label], key: item.id, item: item, onHandleClick: this.onHandleClickCheckboxItem }));
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const { className, data = {} } = this.props;
        let transactioFee = ""; // E-105
        let dropDownValue = ""; // E-105
        const emailSettings = Object.values(data).filter(setting => emailSettingIds.includes(setting.id));
        // E-053
        const emailOrderApprovalSettings = Object.values(data).filter(setting => emailSettingOfOrderApproval.includes(setting.id));
        // E-053
        const otherSettings = Object.values(data).filter(setting => !emailSettingIds.includes(setting.id) && !emailSettingOfOrderApproval.includes(setting.id));
        const byTitle = ramda_1.groupBy(setting => setting.title);
        const emailSettingsByTitle = byTitle(emailSettings);
        dropDownValue = this.claimApprovalDeterminationValue; // E-105
        transactioFee = this.CompanyMinTransactionFeeValue; // E-105
        let myFinalCall = ((_a = this.site) === null || _a === void 0 ? void 0 : _a.isTransactionFeeUpdated) === false ? (_b = this.site) === null || _b === void 0 ? void 0 : _b.claimApprovalDetermination : (_c = this.site) === null || _c === void 0 ? void 0 : _c.siteClaimApprovalDetermination; // E-105 new
        let DropValCheck = ((_d = this.site) === null || _d === void 0 ? void 0 : _d.siteClaimApprovalDetermination) ? (_e = this.site) === null || _e === void 0 ? void 0 : _e.siteClaimApprovalDetermination : (_f = this.site) === null || _f === void 0 ? void 0 : _f.claimApprovalDetermination; // E-105
        return (React.createElement("div", { className: `settings-container${className ? ` ${className}` : ""}` }, this.site == undefined ? React.createElement("div", { className: "loaderItem" }) :
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "settings general-settings", style: { marginLeft: '15px' } },
                    React.createElement(material_ui_1.Typography, { gutterBottom: true, variant: "headline" }, "General Settings"),
                    otherSettings.map((setting, index) => this.renderItem(setting, index)),
                    React.createElement(switch_1.MaterialSwitch, { label: "Require prescribing provider to dispense", value: "reqPro", onChange: () => {
                            this.site &&
                                (this.site.assignedProviders = !this.site.assignedProviders);
                            callable_1.callable(this.props.onChange)(this.data);
                        }, checked: (this.site && this.site.assignedProviders) || false }),
                    React.createElement("div", { style: { display: "grid", gap: 15, marginTop: 20 } },
                        this.allowCompanyCopayCollection && (React.createElement(switch_1.MaterialSwitch, { label: "CardPointe POS Ability", value: "reqPro", onChange: () => {
                                this.cardPointePosAbility = !this.cardPointePosAbility;
                                callable_1.callable(this.props.onChange)(this.data);
                            }, checked: this.cardPointePosAbility })),
                        this.changeUserStatusForEsign && React.createElement(React.Fragment, null,
                            React.createElement("div", null,
                                React.createElement(switch_1.MaterialSwitch, { label: "Skip e-sign required to dispense", value: "reqPro", onChange: () => {
                                        this.site &&
                                            (this.site.allowSiteForESign = !this.site.allowSiteForESign);
                                        callable_1.callable(this.props.onChange)(this.data);
                                    }, checked: (this.site && this.site.allowSiteForESign) || false })),
                            React.createElement("div", { className: "patient-signature__column", style: { display: 'inline-grid' } }, ((_g = this.site) === null || _g === void 0 ? void 0 : _g.allowSiteForESign) ?
                                React.createElement(React.Fragment, null,
                                    React.createElement(React.Fragment, null, "Collecting Patients Signature"),
                                    React.createElement("select", { style: { padding: '10px 50px 10px 50px' }, onChange: (e) => {
                                            this.site &&
                                                (this.currentDropValue = e.target.value);
                                            (this.site.allowSiteForSelection = e.target.value);
                                            callable_1.callable(this.props.onChange)(this.data);
                                        }, value: this.currentDropValue, defaultValue: (_h = this.site) === null || _h === void 0 ? void 0 : _h.allowSiteForSelection },
                                        React.createElement("option", { value: "e_Sign" }, "e-Sign"),
                                        React.createElement("option", { value: "print_to_Sign" }, "Print to Sign")))
                                :
                                    false)))),
                React.createElement("div", { className: "settings email-settings", style: { marginLeft: '15px' } },
                    React.createElement(material_ui_1.Typography, { gutterBottom: true, variant: "headline" }, "Email Settings"), emailOrderApprovalSettings === null || emailOrderApprovalSettings === void 0 ? void 0 :
                    emailOrderApprovalSettings.map((setting, index) => this.renderItem(setting, index)),
                    Object.entries(emailSettingsByTitle)
                        .filter(([title]) => title === "")
                        .map(([, settings]) => settings.map((setting, index) => this.renderItem(setting, index))),
                    Object.entries(emailSettingsByTitle)
                        .filter(([title]) => title !== "")
                        .map((entry, index) => this.renderEmailSettings(entry, index))),
                this.props.isStatusCancel &&
                    React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Save", cancelText: "Cancel", 
                        // message={`Are you sure you want to disable ${"hellow"}?`} // E-105 new
                        onCancel: this.props.onCloseModal, onConfirm: () => this.props.onConfirmFlag(this.cardPointePosAbility), title: "Are you sure you want to make these changes?" }),
                React.createElement("div", { className: "settings email-settings", style: { marginLeft: '15px' } },
                    React.createElement(material_ui_1.Typography, { gutterBottom: true, variant: "headline" }, "Financial Settings"),
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { style: { display: 'grid', gap: 5 } },
                            React.createElement("span", null, "Claim Approval Determination"),
                            React.createElement("select", { style: { padding: 10 }, onChange: (e) => {
                                    this.site &&
                                        (dropDownValue = e.target.value);
                                    (this.site.siteClaimApprovalDetermination = e.target.value);
                                    this.site.isTransactionFeeUpdated = true;
                                    callable_1.callable(this.props.onChange)(this.data);
                                }, defaultValue: ((_j = this.site) === null || _j === void 0 ? void 0 : _j.siteClaimApprovalDetermination) ? (_k = this.site) === null || _k === void 0 ? void 0 : _k.siteClaimApprovalDetermination : (_l = this.site) === null || _l === void 0 ? void 0 : _l.claimApprovalDetermination },
                                React.createElement("option", { value: "grossProfit" }, "Gross Profit - (Consider without Copay Amount)"),
                                React.createElement("option", { value: "netProfit" }, "Net Profit - (Consider with Copay Amount)")),
                            React.createElement("div", { style: { display: 'contents' } },
                                React.createElement("span", null, "Minimum Transaction Fee"),
                                React.createElement("input", { style: { marginLeft: 0, padding: 10 }, type: "text", placeholder: "$0.01", onKeyDown: (event) => {
                                        if (event.keyCode === 38 || // ArrowUp
                                            event.keyCode === 40 || // ArrowDown
                                            event.key === '+' ||
                                            event.key === '-' ||
                                            event.key === 'Add' ||
                                            event.keyCode === 187 ||
                                            event.key === 'Enter') {
                                            event.preventDefault();
                                        }
                                    }, onBlur: (e) => {
                                        let value = parseFloat(e.target.value.replace(/[^0-9.]/g, ''));
                                        if (isNaN(value) || value < 0.01)
                                            value = 0.01;
                                        const formattedValue = `$${value.toFixed(2)}`;
                                        this.site && (this.site.siteMinTransactionFee = value.toFixed(2));
                                        callable_1.callable(this.props.onChange)(this.data);
                                        if (formattedValue)
                                            this.site.isTransactionFeeUpdated = true;
                                        e.target.value = formattedValue;
                                    }, onChange: (e) => {
                                        let input = e.target.value.replace(/[^0-9.]/g, '');
                                        this.site && (this.site.siteMinTransactionFee = input);
                                        if (this.site.siteClaimApprovalDetermination.length === 0) {
                                            this.site.siteClaimApprovalDetermination = 'netProfit';
                                        }
                                        callable_1.callable(this.props.onChange)(this.data);
                                        e.target.value = input ? `$${input}` : '';
                                    }, defaultValue: this.site.siteMinTransactionFee
                                        ? `$${parseFloat(this.site.siteMinTransactionFee).toFixed(2)}`
                                        : ((_m = this.site) === null || _m === void 0 ? void 0 : _m.CompanyMinTransactionFee) ? `$${parseFloat(this.site.CompanyMinTransactionFee).toFixed(2)}`
                                            : '$0.01' }))))))));
    }
};
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "site", void 0);
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "frequencyDaily", void 0);
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "allowCompanyCopayCollection", void 0);
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "cardPointePosAbility", void 0);
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "changeUserStatusForEsign", void 0);
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "checkboxSelections", void 0);
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "currentDropValue", void 0);
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "claimApprovalDeterminationValue", void 0);
__decorate([
    mobx_1.observable
], SettingsComponent.prototype, "CompanyMinTransactionFeeValue", void 0);
SettingsComponent = __decorate([
    mobx_react_1.observer
], SettingsComponent);
exports.SettingsComponent = SettingsComponent;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/settings/settings.tsx
// module id = 4062
// module chunks = 0